export default Object.freeze({
  B: 'B',
  Y: 'Y',
  N: 'N',
})
